import React from 'react'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import type { WorkOrder } from '@ztechapps/common.contract'
import { ExpandToggleCell } from './ExpandToggleCell'
import { DataListRow } from './DataListRow'

export type ListRowProps = {
  level?: number
  isExpanded?: boolean
  onToggleExpand?: (e: any) => void
} & BodyRowConfig<WorkOrder>

export const ListRow = ({ level = 0, isExpanded = false, onToggleExpand, ...props }: ListRowProps) => {
  return (
    <>
      <RowNumberBodyCell {...props} />
      <ExpandToggleCell
        hasChildren={props.hasChildren}
        isExpanded={isExpanded}
        onToggle={onToggleExpand}
        level={level}
      />

      <DataListRow {...props} />
    </>
  )
}
